// npm
import { check } from '@xams-utils/check-types';

// entity
import { Version } from './index';

// errors
import * as errors from './errors';
var versionType = function versionType(version) {
  if (!Version.is(version)) {
    throw errors.VERSION_TYPE;
  }
};
var versionFormat = function versionFormat(versionArray) {
  if (versionArray.length < 1) {
    throw errors.VERSION_FORMAT_MINIMUM;
  }
  if (versionArray.length > 4) {
    throw errors.VERSION_FORMAT_MAXIMUM;
  }
  versionArray.forEach(function (part) {
    if (check.string(part)) {
      if (!check.match(part, /^\d+$/)) {
        throw errors.VERSION_FORMAT;
      }
    } else if (!check.integer(part) || check.negative(part)) {
      throw errors.VERSION_FORMAT;
    }
  });
};
var equalsExact = function equalsExact(exact) {
  if (!check.boolean(exact)) {
    throw errors.EXACT_TYPE;
  }
};
export { versionType, versionFormat, equalsExact };